import React from 'react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border py-12 md:py-16">
      <div className="container-narrow">
        <div className="space-y-6">
          <p className="text-small text-foreground font-medium">
            Bliu Interactive Ltd.
          </p>

          <p className="text-small text-muted max-w-md">
            This is a private engagement. We do not accept inbound inquiries
            outside of the structured brief process.
          </p>

          <div className="pt-6 border-t border-border">
            <p className="text-caption text-muted">
              &copy; {currentYear} Bliu Interactive. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
